exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ScrollStyle{max-height:800px;max-width:100%;overflow-x:scroll;overflow-y:scroll}", ""]);

// exports
